import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Shared hook for loading editable lesson content from the API.
 * Falls back to provided defaults if no overrides exist in the DB.
 */
export function useLessonContent(moduleKey, defaultSections = {}, defaultArrays = {}) {
  const [sections, setSections] = useState(defaultSections);
  const [arrays, setArrays] = useState(defaultArrays);

  useEffect(() => {
    if (!moduleKey) return;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/admin/lesson-content/${moduleKey}`);
        if (res.ok) {
          const data = await res.json();
          if (data.content && Object.keys(data.content).length > 0) {
            setSections(prev => {
              const merged = { ...prev };
              for (const [k, v] of Object.entries(data.content)) {
                if (v !== undefined && v !== '') merged[k] = v;
              }
              return merged;
            });
          }
          if (data.feasts && Object.keys(data.feasts).length > 0) {
            setArrays(prev => {
              const merged = { ...prev };
              for (const [k, v] of Object.entries(data.feasts)) {
                if (v?.length > 0) merged[k] = v;
              }
              return merged;
            });
          }
        }
      } catch { /* use defaults */ }
    })();
  }, [moduleKey]);

  /** Get a text section value with fallback */
  const c = (key, fallback) => sections[key] || fallback || '';

  /** Get an array section */
  const arr = (key) => arrays[key] || defaultArrays[key] || [];

  return { c, arr, sections, arrays };
}
